// extracted by mini-css-extract-plugin
module.exports = {"title":"Front_title__2gOCE","front":"Front_front__1IFIY"};